import * as React from 'react'
import { SubscriptionCode, SubscriptionDetails } from '@modules/subscription/models'
import Table from '@components/table/table'
import { useModal } from '@components/modals/use-modal'
import { CopyToClipboard } from '@components/copy-to-clipboard'
import { getYear } from 'date-fns'
import { parseISODate } from '@helpers/date-helper'
import { SubscriptionDetailsCodeName } from '@modules/subscription/details/code-name'
import { formatPriceShort } from '@helpers/utils'
import { SubscriptionCodeConversionRevert } from '@modules/subscription/details/code-convert/code-conversion-revert'

interface Props {
  createdYear: number
  subscriptionCode: SubscriptionCode
  subscriptionDetails: SubscriptionDetails
}

export const SubscriptionDetailsCodesRowCode: React.FC<Props> = ({
  subscriptionDetails,
  subscriptionCode,
  createdYear,
}) => {
  const [handleEditCode] = useModal('SubscriptionCodeEditModal', { subscriptionCode })

  return (
    <Table.Cell width={220}>
      <span onClick={handleEditCode} className="cursor-pointer">
        {subscriptionCode.code}
      </span>
      <CopyToClipboard className="uil-share-alt ml-1" value={subscriptionCode.code} />
      {subscriptionCode.subscription_kind_display &&
        subscriptionCode.subscription_kind_display !== subscriptionDetails.kind_display && (
          <div className="d-flex align-items-center mt-1">
            <div className="font-11">
              Skonwertowany na: <strong>{subscriptionCode.subscription_kind_display}</strong>
            </div>
            <SubscriptionCodeConversionRevert
              subscriptionDetails={subscriptionDetails}
              subscriptionCode={subscriptionCode}
              kind="single_code_kind_convert"
            />
          </div>
        )}
      {subscriptionCode.has_conversion_deposit && (
        <div className="d-flex align-items-center mt-1">
          <div className="font-11">
            Skonwertowany na: <strong>z kaucją</strong>
          </div>
        </div>
      )}
      <SubscriptionDetailsCodeName subscriptionCode={subscriptionCode} subscriptionDetails={subscriptionDetails} />
      {subscriptionCode.features.map(feature => (
        <div key={feature.id} className="mt-1 font-11">
          Dostępny:{' '}
          {feature.years.length === 0 ? (
            <strong>od dziś do {getYear(parseISODate(subscriptionDetails.expire_after) as Date)}</strong>
          ) : (
            <strong>{feature.years.map(year => createdYear + year).join(', ')}</strong>
          )}
          <br />
          {feature.gastro_gift && (
            <>
              Voucher Gastro <strong>{formatPriceShort(feature.gastro_gift)} </strong>
              <br />
            </>
          )}
          {feature.package_vip && (
            <>
              Pakiet VIP: <strong>{feature.package_vip}</strong>
              <br />
            </>
          )}
          {feature.code_with_benefit && (
            <>
              Dostęp do <strong>oferty specjalnej</strong>
              <SubscriptionCodeConversionRevert
                subscriptionDetails={subscriptionDetails}
                subscriptionCode={subscriptionCode}
                kind="upgrade_to_purple"
              />
            </>
          )}
        </div>
      ))}
    </Table.Cell>
  )
}
